function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("circle", {
  cx: 58,
  cy: 57.5,
  r: 57.5,
  fill: "#D9D9D9"
});
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M77.7656 53.9063C77.7656 57.8155 76.6064 61.637 74.4345 64.8874C72.2627 68.1379 69.1757 70.6713 65.564 72.1673C61.9523 73.6633 57.9781 74.0548 54.1439 73.2921C50.3098 72.5294 46.7879 70.6469 44.0236 67.8827C41.2593 65.1184 39.3768 61.5965 38.6142 57.7623C37.8515 53.9282 38.243 49.954 39.739 46.3423C41.235 42.7306 43.7684 39.6436 47.0188 37.4717C50.2693 35.2999 54.0907 34.1406 58 34.1406C63.2422 34.1406 68.2697 36.2231 71.9764 39.9298C75.6832 43.6366 77.7656 48.6641 77.7656 53.9063ZM104.719 57.5C104.719 66.7401 101.979 75.7727 96.8452 83.4556C91.7117 91.1384 84.4152 97.1265 75.8785 100.663C67.3418 104.199 57.9482 105.124 48.8856 103.321C39.8231 101.518 31.4986 97.0689 24.9649 90.5352C18.4311 84.0014 13.9816 75.6769 12.179 66.6144C10.3763 57.5518 11.3015 48.1582 14.8375 39.6215C18.3736 31.0848 24.3616 23.7883 32.0445 18.6548C39.7273 13.5213 48.7599 10.7813 58 10.7812C70.3833 10.805 82.2526 15.7348 91.0089 24.4911C99.7653 33.2474 104.695 45.1167 104.719 57.5ZM97.5313 57.5C97.5336 51.0975 95.9809 44.7902 93.0064 39.1205C90.032 33.4508 85.725 28.5884 80.4557 24.9514C75.1865 21.3144 69.1127 19.0118 62.7567 18.2414C56.4007 17.471 49.9526 18.2559 43.9671 20.5287C37.9815 22.8015 32.6376 26.4942 28.3948 31.2891C24.152 36.084 21.1373 41.8377 19.61 48.0554C18.0827 54.2731 18.0885 60.7687 19.6268 66.9837C21.1652 73.1987 24.1901 78.947 28.4414 83.7344C31.3505 79.5615 35.0992 76.0423 39.4473 73.4023C44.4397 78.1852 51.0863 80.8553 58 80.8553C64.9137 80.8553 71.5604 78.1852 76.5528 73.4023C80.9009 76.0423 84.6496 79.5615 87.5586 83.7344C93.9943 76.5125 97.5445 67.1733 97.5313 57.5Z",
  fill: "white"
});
const SvgPhotoUpload = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 115,
    viewBox: "0 0 116 115",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPhotoUpload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/photo-upload.29e420a8.svg";
export { ForwardRef as ReactComponent };